import React from 'react';
import { useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';

const UnauthorizedPage = () => {
  const history = useHistory();

  return (
    <Result
      status="403"
      title="403 - Accès Interdit"
      subTitle="Désolé, vous n'êtes pas autorisé à accéder à cette page."
      extra={
        <Button 
          type="primary" 
          onClick={() => history.push('/rapports')} // Modifiez '/rapports' si votre page d'accueil est différente
        >
          Retourner à l'accueil
        </Button>
      }
    />
  );
};

export default UnauthorizedPage;